import stbAPIGateway from '../../../../services/stbAPIGateway';

// eslint-disable-next-line import/prefer-default-export
export const patchClientMaintenanceMode = async (
  { rootGetters, dispatch },
  { clientSid, maintenanceMode }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.patchClientMaintenanceModeBySid(clientSid, maintenanceMode);
  return response;
};
